import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador, Funcionario } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';
import { SeletorMultiploDepartamentosComponent } from '../../shared/seletor-multiplo-departamentos.component';

@Component({
  selector: 'app-filtros-pendencia-ponto',
  standalone: true,
  imports: [CommonModule, FormsModule, BuscaPesquisavelComponent, SeletorMultiploDepartamentosComponent],
  templateUrl: './filtros-pendencia-ponto.component.html'
})
export class FiltrosPendenciaPontoComponent {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() departamentos: Departamento[] = [];
  @Input() departamentoSelecionado: string[] = [];
  @Input() funcionariosFiltrados: Funcionario[] = [];
  @Input() buscaFuncionario = '';
  @Input() dataInicial = '';
  @Input() dataFinal = '';
  @Input() rotuloFuncionario: (item: unknown) => string = () => '';
  @Input() detalheFuncionario: (item: unknown) => string = () => '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() departamentoSelecionadoChange = new EventEmitter<string[]>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() buscaFuncionarioChange = new EventEmitter<string>();
  @Output() digitouFuncionario = new EventEmitter<string>();
  @Output() selecionarFuncionario = new EventEmitter<unknown>();
  @Output() abrirModalFuncionario = new EventEmitter<void>();
  @Output() dataInicialChange = new EventEmitter<string>();
  @Output() dataFinalChange = new EventEmitter<string>();
  @Output() pesquisar = new EventEmitter<void>();
  @Output() limpar = new EventEmitter<void>();
  @Output() imprimir = new EventEmitter<void>();

  selecionarEmpregador(valor: string) {
    this.empregadorSelecionadoChange.emit(valor);
    this.alterarEmpregador.emit();
  }
}
